/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useRef,
  ChangeEvent,
  KeyboardEvent,
  ClipboardEvent,
  FocusEvent,
} from 'react'

import { SingleInputBoxesProps } from './SingleInputBoxes.types'
import InputBox from '../index'
import { Container } from './styles'

export function SingleInputBoxes({
  ...props
}: SingleInputBoxesProps): JSX.Element {
  const elementsRef = useRef<HTMLDivElement>()

  function handleFocus({ target }: FocusEvent<HTMLInputElement>) {
    const el = target
    // In most browsers .select() does not work without the added timeout.
    setTimeout(() => {
      el.select()
    }, 0)
  }

  function focusPrevChar(target: HTMLInputElement) {
    const previousElementSibling =
      target.previousElementSibling as HTMLInputElement
    if (previousElementSibling !== null) {
      previousElementSibling.focus()
    }
  }

  function focusNextChar(target: HTMLInputElement) {
    const nextElementSibling = target.nextElementSibling as HTMLInputElement
    if (nextElementSibling !== null) {
      nextElementSibling.focus()
    }
  }

  function setModuleOutput() {
    const updatedCharacters = []
    elementsRef?.current?.childNodes.forEach((inputEl: any) => {
      updatedCharacters.push(inputEl.value)
    })
    props?.onChangeValueInputBox(updatedCharacters.join(''))
  }

  function handleChange({ target }: ChangeEvent<HTMLInputElement>) {
    setModuleOutput()
    focusNextChar(target)
  }

  function handleKeyDown({ target, key }: KeyboardEvent<HTMLInputElement>) {
    const data = target as HTMLInputElement
    if (key === 'Backspace') {
      if (data.value === '' && data.previousElementSibling !== null) {
        const previousElementSibling =
          data.previousElementSibling as HTMLInputElement
        previousElementSibling.value = ''
        focusPrevChar(data)
      } else {
        data.value = ''
      }
      setModuleOutput()
    } else if (key === 'ArrowLeft') {
      focusPrevChar(data)
    } else if (key === 'ArrowRight' || key === ' ') {
      focusNextChar(data)
    }
  }

  function setValueInputs(values: string[]) {
    elementsRef?.current?.childNodes.forEach((inputEl: any, index: number) => {
      inputEl.value = values[index] ?? ''
      if (!values[index]) {
        handleFocus({
          target: inputEl as HTMLInputElement,
        } as FocusEvent<HTMLInputElement>)
      }
    })
  }

  function handlePaste(e: ClipboardEvent<HTMLInputElement>) {
    const data = e.clipboardData.getData('text')
    setValueInputs(Array.from(data))
    setModuleOutput()
  }

  function renderItems() {
    const items = []

    for (let i = 0; i < props.amount; i++) {
      items.push(
        <InputBox
          id={`input-box-${i}`}
          name={`input-box-${i}`}
          type={props.type}
          key={i}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
          onFocus={handleFocus}
          onPaste={handlePaste}
        />,
      )
    }
    return items
  }

  return <Container ref={elementsRef}>{renderItems()}</Container>
}
